import { useQuery } from "@tanstack/react-query";
import { useMembers } from "./useMembers";
import { usersService } from "../api/users";
import type { MemberRole } from "../api/types";

export const meKey = ["chat", "me"] as const;

export function useMe() {
  return useQuery({ queryKey: meKey, queryFn: () => usersService.me(), staleTime: Infinity });
}

/** "owner" | "manager" | "member" | null in the given conversation. */
export function useChatRole(conversationId: string | undefined): MemberRole | null {
  const me = useMe();
  const members = useMembers(conversationId);
  if (!me.data || !members.data) return null;
  return members.data.find((m) => m.user.sub === me.data!.sub)?.role ?? null;
}
